module.exports = __webpack_public_path__ + "static/media/fish.c12e62ab.png";